import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-2 border-[#2563EB] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" state={{ from: location }} replace />;
  return children;
}
